var map = {
	"./en": [
		70,
		0
	],
	"./en.json": [
		70,
		0
	],
	"./es": [
		71,
		1
	],
	"./es.json": [
		71,
		1
	],
	"./fr": [
		72,
		2
	],
	"./fr.json": [
		72,
		2
	],
	"./zh": [
		73,
		3
	],
	"./zh.json": [
		73,
		3
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 63;
module.exports = webpackAsyncContext;